import React, { ComponentProps, FunctionComponent } from "react";

const CheckCircleIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 14",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 7.00035C14 3.13413 10.8657 0 6.9993 0C3.13289 0 -0.000699815 3.13413 0 7.00035C0 10.8659 3.13289 14 6.9993 14C10.8657 14 14 10.8659 14 7.00035ZM11.0483 5.01174L9.95171 3.98826L5.83333 8.40081L4.04829 6.48826L2.95171 7.51174L5.28504 10.0117L5.83333 10.5992L6.38162 10.0117L11.0483 5.01174Z",
    })
  );
};

const ForwardRef = React.forwardRef(CheckCircleIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
